import { m } from 'framer-motion';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// utils
// import { fPercent } from 'src/utils/format-number';
// components
import Image from 'src/components/image';
import { MotionViewport, varFade } from 'src/components/animate';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';

// ----------------------------------------------------------------------

export default function AboutWhat() {
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  const isLight = theme.palette.mode === 'light';

  const shadow = `-40px 40px 80px ${alpha(
    isLight ? theme.palette.grey[500] : theme.palette.common.black,
    0.24
  )}`;

  const [isInView, setIsInView] = useState(false);
  const whatRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = whatRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <Container
      component={MotionViewport}
      sx={{
        py: { xs: 10, md: 15 },
        textAlign: { xs: 'center', md: 'unset' },
      }}
    >
      <Grid container columnSpacing={{ md: 3 }} alignItems="flex-start" spacing={2}>
        {mdUp && (
          <Grid
            container
            xs={12}
            md={6}
            lg={7}
            alignItems="center"
            sx={{ pr: { md: 7 }, spacing: 2 }}
          >
            <Grid xs={6} sx={{ p: 1 }}>
              <m.div variants={varFade().inUp}>
                <Image
                  alt="chef-love"
                  src="/assets/images/about/smarter-2.png"
                  ratio="1/1"
                  sx={{ borderRadius: 3, boxShadow: shadow }}
                />
              </m.div>
            </Grid>

            <Grid xs={6} sx={{ p: 1 }}>
              <m.div variants={varFade().inUp}>
                <Image
                  alt="smarter"
                  src="/assets/images/about/smarter-3.png"
                  ratio="1/1"
                  sx={{ borderRadius: 3, boxShadow: shadow }}
                />
              </m.div>
            </Grid>

            <Grid xs={6} sx={{ p: 1 }}>
              <m.div variants={varFade().inUp}>
                <Image
                  alt="third-image"
                  src="/assets/images/about/smarter-1.png"
                  ratio="1/1"
                  sx={{ borderRadius: 3, boxShadow: shadow }}
                />
              </m.div>
            </Grid>

            <Grid xs={6} sx={{ p: 1 }}>
              <m.div variants={varFade().inUp}>
                <Image
                  alt="fourth-image"
                  src="/assets/images/about/smarter-4.png"
                  ratio="1/1"
                  sx={{ borderRadius: 3, boxShadow: shadow }}
                />
              </m.div>
            </Grid>
          </Grid>
        )}

        <Grid xs={12} md={6} lg={5}>
          <m.div variants={varFade().inRight}>
            {isInView && (
              <Helmet>
                <title>About Us | What is Cartify?</title>
              </Helmet>
            )}
            <Typography variant="h2" sx={{ mb: 3 }} ref={whatRef}>
              What is Cartify?
            </Typography>
          </m.div>

          <m.div variants={varFade().inRight}>
            <Typography
              sx={{
                textAlign: 'justify',
                color: theme.palette.mode === 'light' ? 'text.secondary' : 'common.white',
              }}
            >
              At Cartify, we recognize the unique challenges faced by the food and beverage (F&B)
              industry. Whether you operate a restaurant, café, catering business, or food supply
              company, our platform is designed to streamline your ordering process, boost
              efficiency, and ensure smooth transactions between operators and suppliers.
              <br />
              Cartify is a specialized B2B platform built exclusively for F&B businesses. We bridge
              the gap between trusted food suppliers and operators, offering a fast, reliable, and
              secure solution for:
              <br />
              <b>Real-Time Ordering</b> – No More Stock Issues!.
              <br />
              <b>Order Tracking</b> – Full Transparency, Every Step of the Way.
              <br />
              <b>Personalized User Accounts</b> – A Shopping Experience Built for You.
            </Typography>
          </m.div>

          <m.div variants={varFade().inRight}>
            <Typography
              sx={{
                marginTop: 2,
                textAlign: 'justify',
                color: theme.palette.mode === 'light' ? 'text.secondary' : 'common.white',
              }}
            >
              Cartify is a specialized B2B platform designed exclusively for F&B businesses. We
              bridge the gap between food suppliers and operators, offering a fast, reliable, and
              secure way to manage orders, track deliveries-all in one place.
            </Typography>
          </m.div>

          {/* // TODO!: GI Add button request demo */}
        </Grid>
      </Grid>
    </Container>
    // </Box>
  );
}
